import { render, staticRenderFns } from "./IGCommands.vue?vue&type=template&id=4dc6c0b3&"
import script from "./IGCommands.vue?vue&type=script&lang=js&"
export * from "./IGCommands.vue?vue&type=script&lang=js&"
import style0 from "./IGCommands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports